import React from 'react'

export const SlideItem = ({ slide, className }) => {
	return (
		<div className={className}>
			<img src={slide} alt='slide' style={{ aspectRatio: '9/6 auto' }} />
		</div>
	)
}
